import { Typography } from '@mui/material';

interface PmiTitleProps {
  title: string;
  paddingBottom?: number;
  paddingTop?: number;
}

const PmiTitle = ({
  title,
  paddingBottom = 3,
  paddingTop = 4,
}: PmiTitleProps): React.ReactElement => {
  return (
    <div className={`pmi-pt-${paddingTop} pmi-pb-${paddingBottom}`}>
      <Typography
        color="secondary.main"
        style={{
          fontSize: '26px',
        }}
      >
        {title}
      </Typography>
    </div>
  );
};

PmiTitle.displayName = 'Pmi Title component';

export default PmiTitle;
